/* Homepage visual enhancement only; native product and app behavior remains with Shopify/Loox. */
(()=>{
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){if(!reduced.matches)entry.target.classList.add('p2-has-entered');observer.unobserve(entry.target)}}},{threshold:.18}):null;
 const shopProducts={
  '/products/delta-9-thc-gummies':{name:'Voyage',vibe:'The full ride',family:'voyage',pack:'phntm-voyage.webp'},
  '/products/1-1-delta-9-thc-cbd-gummies':{name:'Daily Cruiser',vibe:'Everyday chill',family:'daily',pack:'phntm-daily-cruiser.webp'},
  '/products/deep-thc-cbn-gummies':{name:'Deep Sleep',vibe:'Night-night mode',family:'sleep',pack:'phntm-deep-sleep.webp'},
  '/products/phntm-odyssey-collection':{name:'Odyssey',vibe:'Meet the whole crew',family:'odyssey'}
 };
 function styleShopMenu(summaryId,mobile){
  const summary=document.getElementById(summaryId),details=summary?.closest('details');
  if(!details)return;
  const panel=details.querySelector(mobile?'.menu-drawer__inner-submenu':'.mega-menu__content');
  const list=panel?.querySelector('ul');if(!panel||!list)return;
  details.classList.add(mobile?'p2-shop-drawer':'p2-shop-menu');list.classList.add('p2-shop-list');
  if(!panel.querySelector('.p2-shop-intro')){
   const intro=document.createElement('div');intro.className='p2-shop-intro';
   const copy=document.createElement('div'),kicker=document.createElement('p'),title=document.createElement('p');
   kicker.className='p2-shop-kicker';kicker.textContent='YOUR DAY. YOUR NIGHT. YOUR CALL.';
   title.className='p2-shop-title';title.textContent='PICK YOUR VIBE.';
   copy.append(kicker,title);intro.append(copy);
   const mascot=document.createElement('span');mascot.className='p2-shop-mascot';mascot.setAttribute('aria-hidden','true');intro.append(mascot);list.before(intro);
  }
  const css=document.querySelector('link[href*="phntm-v2.css"]');
  for(const link of list.querySelectorAll('a[href]')){
   if(link.dataset.phntmShopReady)continue;
   const product=shopProducts[new URL(link.href,location.href).pathname.replace(/\/$/,'')];if(!product)continue;
   link.dataset.phntmShopReady='true';link.classList.add('p2-shop-card','p2-shop-card--'+product.family);
   // Preserve the original destination, anchor identity, accessible product description and handlers.
   if(!link.hasAttribute('aria-label'))link.setAttribute('aria-label',link.textContent.trim());
   const name=link.querySelector('span');if(name){name.classList.add('p2-shop-name');name.textContent=product.name}
   const image=link.querySelector('img');
   if(image){image.classList.add('p2-shop-pack');if(product.pack&&css){image.src=new URL(product.pack,css.href).href;image.removeAttribute('srcset');image.removeAttribute('data-src');image.removeAttribute('data-srcset');image.width=900;image.height=750}}
   const note=document.createElement('span');note.className='p2-shop-note';note.textContent=product.vibe;link.append(note);
  }
 }
 function enhanceReviewSlider(slider){
  if(slider.dataset.sliderReady)return;
  slider.dataset.sliderReady='true';
  const track=slider.querySelector('.p2-review-deck'),cards=[...track.querySelectorAll('.p2-review-card')];
  const controls=slider.querySelector('.p2-review-controls'),position=slider.querySelector('.p2-review-position');
  const previous=slider.querySelector('[data-review-step="-1"]'),next=slider.querySelector('[data-review-step="1"]');
  if(!cards.length)return;
  let current=0,max=0,frame;
  const offset=index=>cards[index].offsetLeft-cards[0].offsetLeft;
  function update(){
   const gap=parseFloat(getComputedStyle(track).columnGap)||0;
   const visible=Math.max(1,Math.round((track.clientWidth-24+gap)/(cards[0].offsetWidth+gap)));
   max=Math.max(0,cards.length-visible);
   current=cards.reduce((best,card,i)=>Math.abs(offset(i)-track.scrollLeft)<Math.abs(offset(best)-track.scrollLeft)?i:best,0);
   current=Math.min(current,max);
   previous.disabled=current===0;next.disabled=current===max;
   const end=Math.min(cards.length,current+visible);
   position.textContent=(visible===1?String(current+1):(current+1)+'–'+end)+' / '+cards.length;
   controls.hidden=cards.length<=visible;
  }
  function go(index){track.scrollTo({left:offset(Math.max(0,Math.min(max,index))),behavior:reduced.matches?'instant':'smooth'})}
  previous.addEventListener('click',()=>go(current-1));next.addEventListener('click',()=>go(current+1));
  track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});
  track.addEventListener('keydown',event=>{
   if(event.target!==track||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();go(event.key==='Home'?0:event.key==='End'?max:current+(event.key==='ArrowRight'?1:-1));
  });
  if('ResizeObserver' in window){const resize=new ResizeObserver(()=>{if(!slider.isConnected){resize.disconnect();return}update()});resize.observe(track)}
  else window.addEventListener('resize',update);
  update();
 }
 function enhanceOdyssey(product){
  const art=document.getElementById('P2OdysseyArtwork'),media=product.querySelector('.product__media-wrapper');
  if(!art||!media||media.querySelector('.p2-odyssey-art'))return;
  // Keep the real gallery, modal controls and their node identities intact.
  const gallery=media.querySelector('media-gallery');
  if(gallery){
   const details=document.createElement('details'),summary=document.createElement('summary');
   details.className='p2-odyssey-packaging';summary.textContent='Explore the packaging';
   details.append(summary);gallery.before(details);details.append(gallery);
  }
  media.prepend(art.content.cloneNode(true));
  product.classList.add('p2-odyssey-shop');
 }
 function enhanceFooter(){
  const footer=document.querySelector('footer.footer'),signature=document.getElementById('P2FooterSignature');
  if(!footer||!signature)return;
  footer.classList.add('p2-footer');
  // Keep every native link, form, localization control and legal node in place.
  for(const block of footer.querySelectorAll('.footer-block')){
   if(block.querySelector('.footer-block-image')&&!block.querySelector('a,form,input,button'))block.classList.add('p2-footer-original-logo');
  }
  for(const heading of footer.querySelectorAll('.footer-block__heading')){
   const label=heading.textContent.trim().toLowerCase();
   if(label==='phntm information')heading.textContent='Get to know us.';
   if(label==='resources')heading.textContent='The useful stuff.';
  }
  if(!footer.querySelector('.p2-footer-signature')){
   const bottom=footer.querySelector('.footer__content-bottom');
   if(bottom)bottom.before(signature.content.cloneNode(true));else footer.append(signature.content.cloneNode(true));
   footer.querySelector('.p2-footer-top').addEventListener('click',()=>{
    window.scrollTo({top:0,behavior:reduced.matches?'instant':'smooth'});
    document.querySelector('.header__heading-link')?.focus({preventScroll:true});
   });
  }
  const social=footer.querySelector('.footer-block--newsletter'),intro=document.getElementById('P2FooterSocialIntro');
  if(social?.querySelector('.list-social')&&intro&&!social.querySelector('.p2-footer-social-intro')){
   social.classList.add('p2-footer-social');social.prepend(intro.content.cloneNode(true));
  }
 }
 function applySuppliedLogos(){
  const css=document.querySelector('link[href*="phntm-v2.css"]');if(!css)return;
  const logos=[['.header__heading-logo','phntm-logo-horizontal.png',1890,500],['.footer img[src*="Stacked_BW"],.footer img[data-phntm-logo]','phntm-logo-stacked.png',2500,1980]];
  for(const [selector,file,width,height]of logos)for(const img of document.querySelectorAll(selector)){
   if(img.dataset.phntmLogo===file)continue;
   img.src=new URL(file,css.href).href;
   for(const attr of ['srcset','data-src','data-srcset','sizes'])img.removeAttribute(attr);
   img.width=width;img.height=height;img.dataset.phntmLogo=file;
  }
 }
 function enhance(){
  if(!document.body.classList.contains('phntm-v2'))return;
  applySuppliedLogos();
  enhanceFooter();
  styleShopMenu('HeaderMenu-shop',false);styleShopMenu('HeaderDrawer-shop',true);
  document.querySelectorAll('.p2-review-slider').forEach(enhanceReviewSlider);
  document.querySelectorAll('.p2-merch__grid:not([data-scroll-ready])').forEach(rail=>{
   rail.dataset.scrollReady='true';
   rail.addEventListener('keydown',event=>{
    if(event.target!==rail||rail.scrollWidth<=rail.clientWidth+1||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    const step=rail.firstElementChild.offsetWidth+(parseFloat(getComputedStyle(rail).columnGap)||0);
    const left=event.key==='Home'?0:event.key==='End'?rail.scrollWidth:rail.scrollLeft+(event.key==='ArrowRight'?step:-step);
    rail.scrollTo({left,behavior:reduced.matches?'instant':'smooth'});
   });
  });
  const product=document.querySelector('.shopify-section[id$="__8c69ecb6-a0f9-415b-abdc-4776215812de"]');
  if(product){product.classList.add('p2-native','p2-native--odyssey');enhanceOdyssey(product);if(!document.getElementById('p2-odyssey-shop')){const anchor=document.createElement('div');anchor.id='p2-odyssey-shop';product.before(anchor)}}
  if(observer)document.querySelectorAll('.p2-animate-in:not([data-motion-ready])').forEach(card=>{card.dataset.motionReady='true';observer.observe(card)});
  const heading=document.querySelector('h1.header__heading');
  if(heading){const wrapper=document.createElement('div');for(const a of heading.attributes)wrapper.setAttribute(a.name,a.value);while(heading.firstChild)wrapper.appendChild(heading.firstChild);heading.replaceWith(wrapper)}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
 window.addEventListener('w3-scripts-loaded',enhance);document.addEventListener('shopify:section:load',enhance);
})();
